/**
 * 菜单
 * */
import { cloneDeep } from 'lodash';
import { includeArray } from '../../../../libs/system';

// 根据 menu 配置的权限，过滤菜单
function filterMenu(menuList, access, lastList) {
  menuList.forEach(menu => {
    let menuAccess = menu.auth;

    if (!menuAccess || includeArray(menuAccess, access)) {
      let newMenu = {};
      for (let i in menu) {
        if (i !== 'children') newMenu[i] = cloneDeep(menu[i]);
      }
      if (menu.children && menu.children.length) newMenu.children = [];

      lastList.push(newMenu);
      menu.children && filterMenu(menu.children, access, newMenu.children);
    }
  });
  return lastList;
}

// 转换菜单
function convertMenu(source) {
  if (!source) {
    return null;
  }

  // 外部链接
  var reg = /(http|https):\/\/([\w.]+\/?)\S*/;
  return source.map(item => {
    return {
      path: reg.test(item.url) ? item.url : '/' + item.url.split('?')[0],
      code: item.url,
      title: item.name,
      subTitle: item.subName,
      target: item.isNewWindow ? '_blank' : null,
      header: 'home',
      custom: item.icon,
      children: convertMenu(item.subPermissions)
    };
  });
}

export default {
  namespaced: true,
  state: {
    // 顶部菜单
    header: [],
    // 侧栏菜单
    sider: [],
    // 当前顶栏菜单的 name
    headerName: '',
    // 当前所在菜单的 path
    activePath: '',
    // 展开的子菜单 name 集合
    openNames: [],
    // 2.3.0 所有的菜单
    menuSider: [],
    // 2.4.0 菜单徽标
    menuBadge: []
  },
  getters: {
    /**
     * @description 获取侧边菜单
     * */
    sider(state) {
      return state.sider;
    },
    /**
     * @description 根据 user 里登录用户权限，对侧边菜单进行鉴权过滤
     * */
    filterSider(state, getters, rootState) {
      const userInfo = rootState.admin.user.info;
      // @权限
      const access = userInfo.access;

      if (access && access.length) {
        return filterMenu(state.sider, access, []);
      } else {
        return filterMenu(state.sider, [], []);
      }
    },
    /**
     * @description 根据 user 里登录用户权限，对顶栏菜单进行鉴权过滤
     * */
    filterHeader(state, getters, rootState) {
      const userInfo = rootState.admin.user.info;
      // @权限
      const access = userInfo.access;
      if (access && access.length) {
        return state.header.filter(item => {
          let state = true;
          if (item.auth && !includeArray(item.auth, access)) state = false;

          return state;
        });
      } else {
        return state.header.filter(item => {
          let state = true;
          if (item.auth && item.auth.length) state = false;
          return state;
        });
      }
    },
    /**
     * @description 当前 header 的全部信息
     * */
    currentHeader(state) {
      return state.header.find(item => item.name === state.headerName);
    },
    /**
     * @description 在当前 header 下，是否隐藏 sider（及折叠按钮）
     * */
    hideSider(state, getters) {
      let visible = false;
      if (getters.currentHeader && 'hideSider' in getters.currentHeader) visible = getters.currentHeader.hideSider;
      return visible;
    }
  },
  mutations: {
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setSider(state, menu) {
      state.sider = menu;
    },
    /**
     * @description 设置顶栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setHeader(state, menu) {
      state.header = menu;
    },
    /**
     * @description 设置当前顶栏菜单 name
     * @param {Object} state vuex state
     * @param {Array} name headerName
     */
    setHeaderName(state, name) {
      state.headerName = name;
    },
    /**
     * @description 设置当前所在菜单的 path，用于侧栏菜单高亮当前项
     * @param {Object} state vuex state
     * @param {Array} path fullPath
     */
    setActivePath(state, path) {
      state.activePath = path;
    },
    /**
     * @description 设置当前所在菜单的全部展开父菜单的 names 集合
     * @param {Object} state vuex state
     * @param {Array} names openNames
     */
    setOpenNames(state, names) {
      state.openNames = names;
    }
  },
  actions: {
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state vuex state
     * @param {Array} data menu
     */
    setSider({ state, dispatch }, data) {
      let menu = convertMenu(data);

      return new Promise(async resolve => {
        // store 赋值
        state.sider = menu;
        // 持久化
        await dispatch(
          'admin/db/set',
          {
            dbName: 'sys',
            path: 'user.menu',
            value: menu,
            user: true
          },
          { root: true }
        );
        // end
        resolve();
      });
    },
    /**
     * @description 加载侧边栏菜单
     * @param {Object} state vuex state
     */
    loadSider({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        let menu = await dispatch(
          'admin/db/get',
          {
            dbName: 'sys',
            path: 'user.menu',
            defaultValue: {},
            user: true
          },
          { root: true }
        );

        if (!Array.isArray(menu)) {
          menu = [];
        }

        state.sider = menu;

        // end
        resolve();
      });
    }
  }
};
